<template>
  <div class="ima-exhibition-modal">

    <b-field label="Name*">
      <b-input v-model="name" :required="true" ref="autofocus"></b-input>
    </b-field>

    <b-field label="Ort*">
      <b-input v-model="location" required icon="location_on">
      </b-input>
    </b-field>

    <b-field label="Start-Datum*">
      <flat-pickr v-model="startDate" :config="dateConfig"></flat-pickr>
    </b-field>

    <b-field label="End-Datum*">
      <flat-pickr v-model="endDate" :config="dateConfig"></flat-pickr>
    </b-field>

    <div :style="{'text-align': 'right'}">
      <button type="button" class="button is-success" :disabled="!isValidForm" @click="onConfirm">OK</button>
      <button type="button" class="button is-danger" @click="onCancel">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { uniqBy } from 'lodash'
import flatPickr from 'vue-flatpickr-component'
import { mapMutations, mapActions, mapState } from 'vuex'
import {
  saveExhibition,
  unselectExhibition
} from '@/store/modules/exhibitions'
import { closeModals } from '@/store/modules/modals'
import modals from '@/mixins/modals'
import routes from '@/mixins/routes'

import dateConfig from '@/util/dateconfig'

export default {
  name: 'ima-exhibition-modal',
  components: { flatPickr },
  data () {
    return {
      id: null,
      name: '',
      location: '',
      startDate: null,
      endDate: null,
      dateConfig
    }
  },
  computed: {
    ...mapState(['exhibitions']),
    isValidForm () {
      return (
        !!this.name.length && this.location && this.startDate && this.endDate
      )
    },
    options () {
      return {
        locations: uniqBy(this.exhibitions.data.map(({ location }) => location))
      }
    }
  },
  mixins: [modals, routes],
  methods: {
    ...mapActions([saveExhibition]),
    ...mapMutations([closeModals, unselectExhibition]),
    onCancel () {
      this.unselectExhibition()
      this.closeModals()
    },
    onConfirm () {
      const DATE_FORMAT = 'DD.MM.YYYY'
      const { id, name, location, startDate, endDate } = this
      const exhibition = {
        id,
        name,
        location,
        startDate: moment(startDate, DATE_FORMAT).toDate(),
        endDate: moment(endDate, DATE_FORMAT).toDate()
      }
      this.saveExhibition(exhibition).then(exhibition => {
        this.unselectExhibition()
        this.closeModals()
      })
    }
  },
  created () {
    if (this.exhibitions.selectedExhibition) {
      const {
        id,
        location,
        startDate,
        endDate,
        name
      } = this.exhibitions.selectedExhibition
      this.id = id
      this.location = location
      this.name = name
      this.startDate = startDate
      this.endDate = endDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ExhibitionModal.vue